import React from 'react';
//import Icon from 'material-ui/svg-icons/action/stars';
import Icon from 'material-ui/svg-icons/toggle/star';


const style = { opacity: 0.6, width: 15, height: 15, color: '#fd9512' };
const style3 = { opacity: 0.6, width: 15, height: 15, color: '#aaa' };
const style2 = { verticalAlign: 'text-bottom' };

const StarRatingField = ({ rating }) => (
    <span style={style2}>
        {Array(rating).fill(true).map((_, i) => <Icon key={i} style={style} />)}
		{Array((5-rating)).fill(true).map((_, i) => <Icon key={i} style={style3} />)}
    </span>
);

StarRatingField.defaultProps = {
    label: 'resources.reviews.fields.rating',
    source: 'rating',
    addLabel: true,
};

export default StarRatingField;



// WEBPACK FOOTER //
// ./src/review/StarRatingField.js